<template>
    <div class="dialog">
        <el-dialog
            title="温馨提示"
            :visible.sync="isShowTips"
            width="50%"
            :before-close="handleClose"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            top="34vh"
        >
            <div class="section flex-column">
                <img src="../../assets/img/icon-tip2.svg" />
                您还没有进行团队认证，请前往团队认证进行认证
            </div>
            <div slot="footer" class="dialog-footer flex-row">
                <!-- <el-button @click="handleClose">取消</el-button> -->
                <!-- <router-link to="TeamInfo"> -->
                <el-button @click="toPage">去认证</el-button>
                <!-- </router-link> -->
            </div>
        </el-dialog>
    </div>
</template>

<script>
// 引入公共的bus，来做为中间传达的工具
import { eventBus } from "../../utils/eventBus.js";
export default {
    name: "Tips",
    props: {
        isShowTips: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentTab: "",
        };
    },
    mounted() {},
    methods: {
        // 弹窗关闭时触发
        handleClose() {
            this.$emit("changeDialog", false);
        },
        toPage() {
            this.$router.push("TeamInfo");
            this.$emit("changeDialog", false);
            //获取当前路由内设置的currentTab
            this.currentTab = this.$route.meta.currentTab;
            //利用事件总线传递到首页
            eventBus.$emit("setcurrentTab", this.currentTab);
        },
    },
};
</script>

<style scoped>
.content .dialog-footer {
    justify-content: center;
}

.section {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
}

.section img {
    width: 107px;
    height: 107px;
    margin-bottom: 40px;
}

/deep/ .el-dialog__header {
    height: 42px;
    background: #bb2916;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 24px;
    box-sizing: border-box;
    justify-content: space-between;
}

/deep/ .el-dialog__body {
    padding: 32px;
    box-sizing: border-box;
}

/deep/ .el-dialog__title {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff !important;
}

/deep/ .el-dialog__headerbtn {
    width: 16px;
    height: 16px;
    position: inherit;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #ffffff !important;
}

/deep/ .dialog-footer .el-button:first-child {
    width: 374px;
    height: 60px;
    background: #ffffff;
    border-radius: 30px;
    border: 1px solid #bb2916;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #bb2916;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 20px;
}

/deep/ .dialog-footer .el-button:last-child {
    width: 374px;
    height: 60px;
    background: #bb2916;
    border-radius: 30px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
